import { useEffect, useState } from 'react';

import useIsMobile from '@savvy/deprecated-shared/hooks/use-is-mobile';

import { useIsMobileMediaQuery } from './use-is-mobile-media-query';

export function useIsSmallScreen(): boolean {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    setIsHydrated(true);
  }, []);

  const isMobile = useIsMobile();
  const isMuiMobile = useIsMobileMediaQuery();

  return isHydrated && (isMobile || isMuiMobile);
}
